<section class="about-section section-pad overflow-hidden">
    <div class="container-fluid px-lg-5">
        <div class="row align-items-center g-5">
            <!-- Left Text Column -->
            <div class="col-lg-6 animate-on-scroll fade-right">
                <div class="about-content">
                    <span class="about-badge">
                        <span class="badge-dot"></span> About Vaish Girls College
                    </span>
                    <h2 class="about-title mt-3">Welcome To Vaish Girls College, <span
                            class="highlight-text">Samalkha</span></h2>

                    <div class="about-desc-wrap mt-4">
                        <p class="about-desc">
                            Vaish Girls College Samalkha Panipat is affiliated to Kurukshetra University Kurukshetra
                            (KUK). At Vaish College we believe that each teacher is special and has the potential to
                            excel in many different ways.
                        </p>
                        <p class="about-desc">
                            We impart formal education with a difference even as we work within the constraints of a
                            traditional university system. Through carefully crafted interaction and activities within
                            and outside the classroom, we provide experiences that help the pupil teacher discover
                            innate capabilities, set life-long goals and proactively work towards their fulfillment.
                        </p>
                    </div>

                    <!-- Creative Highlights Grid -->
                    <div class="about-highlights-grid mt-5">
                        <div class="highlight-card">
                            <div class="icon-wrap">
                                <i class="fa-solid fa-graduation-cap"></i>
                            </div>
                            <div class="highlight-info">
                                <h4>KUK Affiliated</h4>
                                <p>Affiliated to Kurukshetra University</p>
                            </div>
                        </div>

                        <div class="highlight-card">
                            <div class="icon-wrap">
                                <i class="fa-solid fa-building-shield"></i>
                            </div>
                            <div class="highlight-info">
                                <h4>Govt. Approved</h4>
                                <p>Approved by Govt. of Haryana</p>
                            </div>
                        </div>

                        <div class="highlight-card">
                            <div class="icon-wrap">
                                <i class="fa-solid fa-award"></i>
                            </div>
                            <div class="highlight-info">
                                <h4>A-Grade Campus</h4>
                                <p>Premium Quality Infrastructure</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Right Image Column -->
            <div class="col-lg-6 animate-on-scroll fade-left">
                <div class="about-img-frame-container">
                    <!-- Accent offset border behind image -->
                    <div class="about-img-accent-border"></div>

                    <div class="about-img-wrap">
                        <img src="assets/img/home/home-about-image.jpg" alt="Vaish Girls College, Samalkha"
                            onerror="this.src='https://placehold.co/600x400/0b3d6e/ffffff?text=Vaish+Girls+College'" />
                        <div class="about-img-overlay"></div>
                    </div>

                    <!-- Floating Est. Badge -->
                    <div class="about-est-badge">
                        <div class="badge-inner">
                            <span class="est-year">Est. 1991</span>
                            <span class="est-label">SAMALKHA</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>